import { ChakraFlex } from '@equip.health/ui';

import SurveyListItem from './SurveyListItem';

type SurveyListProps = {
  isDisabled: boolean;
  onCTAClick: (survey: SurveyResponse, isPrimaryCTA: boolean) => void;
  onEditClick: (survey: SurveyResponse) => void;
  patientFirstName: string;
  surveys: SurveyResponse[];
};

const SurveyList = ({ surveys, ...rest }: SurveyListProps) => (
  <>
    {(surveys ?? []).map((survey: SurveyResponse) => (
      <ChakraFlex
        alignItems="center"
        justifyContent="space-between"
        key={`Survey::${survey?.responseExternalId ?? survey?.surveyName}`}
        width="100%"
      >
        <SurveyListItem survey={survey} {...rest} />
      </ChakraFlex>
    ))}
  </>
);

export default SurveyList;
